export enum Role {
  ANONYMOUS = 'utilisateur anonyme',
  AUTHENTICATED = 'authenticated user',
  ADMIN = 'administrateur',
  NOTARY = 'notaire',
  COLLABORATOR = 'collaborateur accès complet',
  COLLABORATOR_LIMITED = 'collaborateur accès limité',
  SF_LISTE = 'sf_liste',
  ACTU_VAL = 'actu_val',
  DEBUG = 'debug',
  STATISTICS_FULL_VIEW = 'STATISTICS_FULL_VIEW',
  REPORTS_REFERENCES_CREATE = 'REPORTS_REFERENCES_CREATE',
  REPORTS_EVALUATIONMANUAL_CREATE = 'REPORTS_EVALUATIONMANUAL_CREATE',
  REPORTS_EVALUATIONAUTOMATIC_CREATE = 'REPORTS_EVALUATIONAUTOMATIC_CREATE',
  SERVICES_HISTORY_LIST = 'SERVICES_HISTORY_LIST',
  SERVICES_HISTORY_ACCESS = 'SERVICES_HISTORY_ACCESS',
  REPORTS_EDIT = 'REPORTS_EDIT',
  REPORTS_DOWNLOAD = 'REPORTS_DOWNLOAD',
  ADMIN_CONSUMPTIONTRACKING_EXPORT = 'ADMIN_CONSUMPTIONTRACKING_EXPORT',
  ADMIN_XNOTACCOUNT_CREATE = 'ADMIN_XNOTACCOUNT_CREATE',
}
